import React, { useState, useEffect, useContext, useRef, useCallback } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { GoogleMap, Marker, useLoadScript, InfoWindow } from "@react-google-maps/api";

const mapContainerStyle = { width: "100%", height: "350px", borderRadius: "10px" };
const containerStyle = { maxWidth: "1000px", margin: "40px auto", padding: "20px", fontFamily: "Arial, sans-serif" };
const arsoStations = [
  { name: "Babno Polje", lat: 45.6452, lng: 14.5449 },
  { name: "Bilje Nova Gorica", lat: 45.8956, lng: 13.624 },
  { name: "Blegoš", lat: 46.1675, lng: 14.0816 },
  { name: "Bohinjska Češnjica", lat: 46.2942, lng: 13.9422 },
  { name: "Boršt Gorenja vas", lat: 46.0854, lng: 14.1819 },
  { name: "Bovec", lat: 46.3317, lng: 13.5538 },
  { name: "Breginj", lat: 46.2625, lng: 13.4275 },
  { name: "Bukovski vrh", lat: 46.1402, lng: 13.8884 },
  { name: "Celje", lat: 46.2366, lng: 15.2259 },
  { name: "Cerkniško jezero", lat: 45.723, lng: 14.399 },
  { name: "Davča", lat: 46.1976, lng: 14.0684 },
  { name: "Dobliče Črnomelj", lat: 45.56, lng: 15.1462 },
  { name: "Dolenje Ajdovščina", lat: 45.8662, lng: 13.9013 },
  { name: "Gačnik", lat: 46.6178, lng: 15.6838 },
  { name: "Godnje", lat: 45.7547, lng: 13.8433 },
  { name: "Gornji Grad", lat: 46.2987, lng: 14.8063 },
  { name: "Hočko Pohorje", lat: 46.4919, lng: 15.5875 },
  { name: "Hrastnik", lat: 46.144, lng: 15.0832 },
  { name: "Idrija", lat: 46.0112, lng: 14.0291 },
  { name: "Ilirska Bistrica", lat: 45.5531, lng: 14.2355 },
  { name: "Iskrba", lat: 45.5612, lng: 14.858 },
  { name: "Jeronim", lat: 46.2668, lng: 14.9481 },
  { name: "Jeruzalem", lat: 46.4759, lng: 16.188 },
  { name: "Jezersko", lat: 46.405, lng: 14.5146 },
  { name: "Kamniška Bistrica", lat: 46.3087, lng: 14.6034 },
  { name: "Kanin", lat: 46.3581, lng: 13.4744 },
  { name: "Kočevje", lat: 45.6458, lng: 14.8496 },
  { name: "Koper Kapitanija", lat: 45.5481, lng: 13.7246 },
  { name: "Koper Markovec", lat: 45.543, lng: 13.7135 },
  { name: "Korensko sedlo", lat: 46.5167, lng: 13.7517 },
  { name: "Krajinski park Goričko", lat: 46.8359, lng: 16.0307 },
  { name: "Kranj", lat: 46.2477, lng: 14.3647 },
  { name: "Kredarica", lat: 46.3787, lng: 13.8489 },
  { name: "Krn", lat: 46.238, lng: 13.658 },
  { name: "Krvavec", lat: 46.2973, lng: 14.5333 },
  { name: "Kubed", lat: 45.52, lng: 13.8689 },
  { name: "Kum", lat: 46.0879, lng: 15.0732 },
  { name: "Lendava", lat: 46.5526, lng: 16.4579 },
  { name: "Letališče Cerklje ob Krki", lat: 45.901, lng: 15.5161 },
  { name: "Letališče Edvarda Rusjana Maribor", lat: 46.4797, lng: 15.6821 },
  { name: "Letališče Jožeta Pučnika Ljubljana", lat: 46.2114, lng: 14.4784 },
  { name: "Letališče Lesce", lat: 46.362, lng: 14.1718 },
  { name: "Letališče Portorož", lat: 45.4753, lng: 13.616 },
  { name: "Lisca", lat: 46.0678, lng: 15.2849 },
  { name: "Litija", lat: 46.0651, lng: 14.8185 },
  { name: "Ljubljana", lat: 46.0655, lng: 14.5124 },
  { name: "Ljubljana - Vič", lat: 46.0375, lng: 14.4893 },
  { name: "Logarska dolina", lat: 46.3936, lng: 14.6311 },
  { name: "Logatec", lat: 45.9077, lng: 14.2032 },
  { name: "Luka Koper", lat: 45.5645, lng: 13.7448 },
  { name: "Malkovec", lat: 45.9531, lng: 15.2049 },
  { name: "Maribor", lat: 46.5678, lng: 15.626 },
  { name: "Marinča vas", lat: 45.8719, lng: 14.8178 },
  { name: "Metlika", lat: 45.6442, lng: 15.3201 },
  { name: "Mežica", lat: 46.5296, lng: 14.8596 },
  { name: "Miklavž na Gorjancih", lat: 45.775, lng: 15.3199 },
  { name: "Murska Sobota", lat: 46.6521, lng: 16.1913 },
  { name: "Nanos", lat: 45.7714, lng: 14.0536 },
  { name: "Nova Gorica", lat: 45.9556, lng: 13.6524 },
  { name: "Nova vas - Bloke", lat: 45.7689, lng: 14.5088 },
  { name: "Novo mesto", lat: 45.8018, lng: 15.1773 },
  { name: "Osilnica", lat: 45.5314, lng: 14.6915 },
  { name: "Otlica", lat: 45.9377, lng: 13.9116 },
  { name: "Park Škocjanske jame", lat: 45.6638, lng: 13.9931 },
  { name: "Pasja ravan", lat: 46.0979, lng: 14.2282 },
  { name: "Pavličevo sedlo", lat: 46.4251, lng: 14.5853 },
  { name: "Piran - oceanografska boja", lat: 45.5481, lng: 13.5454 },
  { name: "Planina pod Golico", lat: 46.4672, lng: 14.0525 },
  { name: "Podčetrtek", lat: 46.1547, lng: 15.6083 },
  { name: "Podnanos", lat: 45.8045, lng: 13.9659 },
  { name: "Postojna", lat: 45.7722, lng: 14.1973 },
  { name: "Predel", lat: 46.4183, lng: 13.5784 },
  { name: "Ptuj", lat: 46.4197, lng: 15.8492 },
  { name: "Radegunda", lat: 46.3661, lng: 14.933 },
  { name: "Rateče", lat: 46.4971, lng: 13.7129 },
  { name: "Ratitovec", lat: 46.2362, lng: 14.0902 },
  { name: "Ravne na Koroškem", lat: 46.5477, lng: 14.94 },
  { name: "Rogaška Slatina", lat: 46.2409, lng: 15.6439 },
  { name: "Rogla", lat: 46.453, lng: 15.3315 },
  { name: "Rudno polje", lat: 46.3463, lng: 13.9235 },
  { name: "Sevno", lat: 45.9821, lng: 14.9236 },
  { name: "Slavnik", lat: 45.5336, lng: 13.976 },
  { name: "Slovenske Konjice", lat: 46.3433, lng: 15.4367 },
  { name: "Sviščaki", lat: 45.5756, lng: 14.3988 },
  { name: "Sveti Trije Kralji na Pohorju", lat: 46.4399, lng: 15.4567 },
  { name: "Šebreljski vrh", lat: 46.0629, lng: 13.9113 },
  { name: "Šmartno pri Slovenj Gradcu", lat: 46.4896, lng: 15.1112 },
  { name: "Tatre", lat: 45.5989, lng: 14.0875 },
  { name: "Topol", lat: 46.0941, lng: 14.3713 },
  { name: "Trbovlje", lat: 46.1575, lng: 15.0539 },
  { name: "Trebnje", lat: 45.911, lng: 15.0072 },
  { name: "Trojane - Limovce", lat: 46.1984, lng: 14.9113 },
  { name: "Tržaški zaliv (Zarja)", lat: 45.6016, lng: 13.5352 },
  { name: "Uršlja gora", lat: 46.4849, lng: 14.9634 },
  { name: "Vedrijan", lat: 46.0131, lng: 13.541 },
  { name: "Velenje", lat: 46.3603, lng: 15.1119 },
  { name: "Velike Lašče", lat: 45.831, lng: 14.6427 },
  { name: "Vogel", lat: 46.2594, lng: 13.8396 },
  { name: "Vrhnika", lat: 45.966, lng: 14.2717 },
  { name: "Vršič", lat: 46.4328, lng: 13.7478 },
  { name: "Zadlog", lat: 45.9395, lng: 14.0023 },
  { name: "Zelenica", lat: 46.4289, lng: 14.233 },
  { name: "Zgornja Kapla", lat: 46.6434, lng: 15.3501 },
  { name: "Zgornja Radovna", lat: 46.424, lng: 13.9352 },
  { name: "Zgornja Sorica", lat: 46.2221, lng: 14.0286 },
];

const messages = [
  "Analiziranje zgodovine vremena...",
  "Združevanje ARSO podatkov...",
  "Napovedovanje vremenskih vzorcev...",
  "Obdelava meteoroloških podatkov...",
  "Generiranje grafične napovedi...",
];

export default function Home() {
  const { user, location, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const { latitude, longitude, localMachine } = location || {};
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyBCQdt2iyMPEu_zeTLximpbgHJ6pOMLwHE",
  });

  const [weatherData, setWeatherData] = useState(null);
  const [predictionData, setPredictionData] = useState([]);
  const [selectedStation, setSelectedStation] = useState(null);
  const [mapCenter, setMapCenter] = useState(null);
  const mapRef = useRef(null);
  const [currentMessage, setCurrentMessage] = useState(0);

  const onLoad = useCallback((map) => {
    mapRef.current = map;
  }, []);

  const handleDragEnd = () => {
    if (mapRef.current) {
      const newCenter = mapRef.current.getCenter().toJSON();
      setMapCenter(newCenter);
    }
  };

  useEffect(() => {
    if (latitude && longitude && !mapCenter) {
      setMapCenter({ lat: latitude, lng: longitude });
    }
  }, [latitude, longitude, mapCenter]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessage((prev) => (prev + 1) % messages.length);
    }, 1050);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!latitude || !longitude) return;

    const fetchLiveWeather = async () => {
      try {
        const res = await fetch(`https://weather-listener.darkosever.si/api/vzivo?lat=${latitude}&lon=${longitude}`);
        const data = await res.json();
        const sourceData = localMachine ? data.naprava : data.arso;
        if (!sourceData) return;
        setWeatherData({
          stanje: localMachine ? "naprava" : "ARSO",
          temp: sourceData.temperatura || "/",
          veter: sourceData.veter || "/",
          vlaga: sourceData.relativnaVlaznost || sourceData.vlaznost || "-",
          padavine: sourceData.padavine || "/",
          lockacija: localMachine ? "naprava" : sourceData.id || "ARSO",
        });
      } catch (err) {
        console.error(err);
      }
    };

    const fetchPrediction = async () => {
      try {
        const res = await fetch(`https://weather-listener.darkosever.si/api/napoved?lat=${latitude}&lon=${longitude}`);
        const result = await res.json();
        setPredictionData(result.napoved || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchLiveWeather();
    fetchPrediction();
  }, [latitude, longitude, localMachine]);

  if (!user || !latitude || !longitude || !mapCenter) return <div style={{ textAlign: "center", marginTop: 50 }}>Nalaganje...</div>;
  if (loadError) return <div>Error loading map</div>;
  if (!isLoaded) return <div>Loading map...</div>;

  const nearestStation = arsoStations.reduce((prev, curr) => {
    const prevDist = Math.hypot(prev.lat - latitude, prev.lng - longitude);
    const currDist = Math.hypot(curr.lat - latitude, curr.lng - longitude);
    return currDist < prevDist ? curr : prev;
  });

  const getPredictionIcon = (vremeOpis) => {
    switch (vremeOpis.toLowerCase()) {
      case "sončno":
        return "☀️";
      case "jasno":
        return "🌞";
      case "oblačno":
        return "☁️";
      case "deževno":
        return "🌦️";
      case "močno deževno":
        return "⛈️";
      case "megleno":
        return "🌫️";
      default:
        return "🌤️"; // Fallback for unknown weather types
    }
  };

  const mapOptions = {
    streetViewControl: false,
    mapTypeControl: false,
    fullscreenControl: false,
  };

  return (
    <div style={containerStyle}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <h1 style={{ margin: 0 }}>Dobrodošel, {user.email}</h1>
        <div>
          <button onClick={() => navigate("/profil")} style={buttonStyle}>Profil</button>
          <button onClick={logout} style={{ ...buttonStyle, backgroundColor: "#e74c3c" }}>Izpis</button>
        </div>
      </div>
      <div style={cardStyle}>
        <h2>Izbrane koordinate</h2>
        <p>Lat: <b>{latitude}</b>, Lon: <b>{longitude}</b></p>
        <button onClick={() => navigate("/izbira")} style={buttonStyle}>Spremeni lokacijo</button>
      </div>
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        zoom={12}
        center={mapCenter}
        onLoad={onLoad}
        onDragEnd={handleDragEnd}
        options={mapOptions}
      >
        <Marker
          position={{ lat: latitude, lng: longitude }}
          icon={{
            url: "https://maps.google.com/mapfiles/kml/shapes/ranger_station.png",
            scaledSize: { width: 40, height: 40 },
          }}
        />
        <Marker
          position={{ lat: nearestStation.lat, lng: nearestStation.lng }}
          title={nearestStation.name}
          icon={{
            url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(`
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20">
                <circle cx="10" cy="10" r="7" fill="#18a529ff">
                  <animate
                    attributeName="r"
                    values="5; 10; 5"
                    dur="3s"
                    repeatCount="indefinite" />
                  <animate
                    attributeName="opacity"
                    values="1; 0.2; 1"
                    dur="3s"
                    repeatCount="indefinite" />
                </circle>
              </svg>
            `),
            scaledSize: { width: 35, height: 35 },
          }}
          onClick={() => setSelectedStation(nearestStation)}
        />
        {arsoStations.map((station, i) => {
          if (station.name === nearestStation.name) return null;
          return (
            <Marker
              key={i}
              position={{ lat: station.lat, lng: station.lng }}
              icon={{
                url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(`
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20">
                    <circle cx="10" cy="10" r="7" fill="#3498db">
                      <animate
                        attributeName="r"
                        values="6; 9; 6"
                        dur="3s"
                        repeatCount="indefinite" />
                      <animate
                        attributeName="opacity"
                        values="0.7; 0.3; 0.7"
                        dur="3s"
                        repeatCount="indefinite" />
                    </circle>
                  </svg>
                `),
                scaledSize: { width: 20, height: 20 },
              }}
              onClick={() => setSelectedStation(station)}
            />
          );
        })}
        {selectedStation && (
          <InfoWindow
            position={{ lat: selectedStation.lat, lng: selectedStation.lng }}
            onCloseClick={() => setSelectedStation(null)}
          >
            <div>{selectedStation.name}</div>
          </InfoWindow>
        )}
      </GoogleMap>
      {weatherData && (
        <div>
          <div style={{ ...cardStyle, display: "flex", justifyContent: "space-around", marginTop: 20 }}>
            <div style={weatherElementStyle}><p>PADAVINE</p><p>{weatherData.padavine}</p></div>
            <div style={weatherElementStyle}><p>TEMP</p><p>{weatherData.temp}°C</p></div>
            <div style={weatherElementStyle}><p>VETER</p><p>{weatherData.veter} km/h</p></div>
            <div style={weatherElementStyle}><p>VLAGA</p><p>{weatherData.vlaga}%</p></div>
          </div>
          <p style={{ textAlign: "center", marginTop: 10, fontSize: 8, fontWeight: "bold" }}>
            Vir podatkov: {weatherData.stanje} (id postaje: {weatherData.lockacija})
          </p>
        </div>
      )}
      {predictionData.length <= 0 && (
        <div
          style={{
            textAlign: "center",
            marginTop: 30,
            fontWeight: "bold",
            fontSize: "1.2em",
            color: "#4A90E2",
            animation: "fade 1.2s ease-in-out infinite",
          }}
        >
          {messages[currentMessage]} ✨
        </div>
      )}
      {predictionData.length > 0 && (
        <div style={{ marginTop: 30 }}>
          <h2>Napoved</h2>
          <div style={{ display: "flex", gap: 15, overflowX: "auto", padding: 10 }}>
            {predictionData.map((item, index) => {
              const label = index === 0 ? "Jutri" : index === 1 ? "Pojutrišnjem" : `Čez ${index + 1} dni`;
              const temp = parseFloat(item.temperatura).toFixed(1);
              //const padavine = parseFloat(item.padavine).toFixed(1);
              return (
                <div key={index} style={predictionCardStyle}>
                  <h4>{label}</h4>
                  <div style={{ fontSize: 40 }}>{getPredictionIcon(item.vremeOpis)}</div>
                  <p>{item.vremeOpis}</p>
                  <p>{temp}°C</p>
                  <p>vlaga: {parseFloat(item.vlaznost).toFixed(1)}%</p>
                  <p>padavine: {item.padavineOpis}</p>
                  <p>tlak: {parseFloat(item.zracniTlak).toFixed(1)} hPa</p>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

const cardStyle = {
  backgroundColor: "#fff",
  padding: 20,
  borderRadius: 12,
  boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
  marginBottom: 20,
};

const buttonStyle = {
  padding: "8px 15px",
  marginLeft: 10,
  borderRadius: 6,
  border: "none",
  cursor: "pointer",
  backgroundColor: "#3498db",
  color: "#fff",
  fontWeight: "bold",
};

const weatherElementStyle = {
  textAlign: "center",
  flex: 1,
  padding: "10px 0",
  borderRight: "1px solid #eee",
};

const predictionCardStyle = {
  minWidth: 150,
  backgroundColor: "#fff",
  borderRadius: 10,
  padding: 10,
  textAlign: "center",
  boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
};

// Inject CSS animation for fade effect
const styles = `
  @keyframes fade {
    0%, 100% { opacity: 0.6; }
    50% { opacity: 1; }
  }
`;

// Inject styles into the document
const styleSheet = document.createElement("style");
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);